import { axios } from '@/plugins/axios-pol'

const BASE_PATH = '/personal/api/EstadoFuerza'

// PERSONAL LITE — lista ligera de personal por dependencia (nombre, puesto, foto, vigenciaC3).
// Vuex: action fetchPersonalByDependencia / getter getFullPersonal (módulo 'personal').
// Usado en: LocPersonal, PersonalEquipamiento, DashboardEnlace, Dashboard (desarrollo_profesional).
async function fetchPersonalByDependencia(idDependencia) {
  const response = await axios.get(`${BASE_PATH}/dependencias/${idDependencia}/personal`)

  const { data } = response.data

  return typeof data === 'string' ? JSON.parse(data) : data
}

async function fetchPersonalByDependenciaYEstatus(idDependencia, estatus) {
  const response = await axios.get(`${BASE_PATH}/dependencias/${idDependencia}/estatus/${estatus}/personal`)

  const { data } = response.data

  return typeof data === 'string' ? JSON.parse(data) : data
}

export default function createPersonalApiRepository() {
  return {
    fetchPersonalByDependencia,
    fetchPersonalByDependenciaYEstatus,
  }
}
